module.exports = __webpack_public_path__ + "assets/images/0a85a282e5ac46d717b7d38633d90b15.png";